import { Callout } from './src/messages/components/Callout'
import { Banner } from './src/messages/components/Banner'

export const message = { Callout, Banner }
